module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-33.e1d66952.svg";